import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#41CAE7',
    },
    secondary: {
      main: '#39BD86',
    },
    error: {
      main: '#FF0000',
    },
  },
});

export default theme;
